import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetails from "./sections/ContactDetails";
import AppointmentRequest from "./sections/AppointmentRequest";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactDetails />
      <AppointmentRequest />
      <FAQ />
      <Footer />
    </div>;
}